export class AppSettings {
    public static SERVER_URL = 'http://localhost:64135/';
    public static Environment = 'Live';
    public static EnvironmentLive = 'Live';
    public static EnvironmentDev = 'Dev';
    public static UserName = '';
    public static IsDevelopment: boolean = true;
    public static GRID_PAGESIZE = 30;

    //verify if token exits...
    public static isPIDTokenExists(): boolean {
        let isValid: boolean = true;
        if (!sessionStorage.getItem('Pid')) {
            isValid = false
        }
        return isValid;
    }
    public static removeAllTokens() {
        sessionStorage.removeItem('Cid');
        sessionStorage.removeItem('Pid');
        sessionStorage.removeItem('PName');
        sessionStorage.removeItem('refNo');
        sessionStorage.removeItem('captcha');
        sessionStorage.removeItem('refCode');
    }

    public static removeTempCertificationId() {
        sessionStorage.removeItem('Cid');;

    }
    public static removeParticipandId() {
        sessionStorage.removeItem('Pid');
    }
    public static removeParticipandName() {
        sessionStorage.removeItem('PName');
    }
    public static removereferenceNumber() {
        sessionStorage.removeItem('refNo');
    }
    public static removereCapcha() {
        sessionStorage.removeItem('captcha');
    }

    public static getReferenceNumber(): string {
        let refNo: string = "";
        if (sessionStorage.getItem('refNo')) {
            refNo = sessionStorage.getItem('refNo');
        }
        return refNo;
    }

    public static getReferenceCode(): string {
        let refCode: string = "";
        if (sessionStorage.getItem('refCode')) {
            refCode = sessionStorage.getItem('refCode');
        }
        return refCode;
    }
  
    public static getCaptchaSiteKey(): string {
        let siteKey: string = "";
        if (sessionStorage.getItem('sK')) {
            siteKey = sessionStorage.getItem('sK');
        }
        return siteKey;
    }

    public static getParticipabtLogoURL(): string {
        let LogoURL: string = "";
        if (sessionStorage.getItem('Logo')) {
            LogoURL = sessionStorage.getItem('Logo');
        }
        return LogoURL;
    }

    public static getCertificationID(): string {
        let Cid: string = "";
        if (sessionStorage.getItem('Cid')) {
            Cid = sessionStorage.getItem('Cid');
        }
        return Cid;
    }

    public static getParticipantID(): string {
        let Pid: string = "";
        if (sessionStorage.getItem('Pid')) {
            Pid = sessionStorage.getItem('Pid');
        }
        return Pid;
    }

    public static getParticipantName(): string {
        let PName: string = "";
        if (sessionStorage.getItem('PName')) {
            PName = sessionStorage.getItem('PName');
        }
        return PName;
    }

    public static isCertificationIdExists(): boolean {

        let isValid: boolean = true;
        if (!sessionStorage.getItem('Cid')) {
            isValid = false
        }
        return isValid;
    }

    public static isCapchaTokenExists(): boolean {
        let isValid: boolean = true;
        if (!sessionStorage.getItem('captcha')) {
            isValid = false
        }
        return isValid;
    }

    public static isReferenceNoExists(): boolean {

        let isValid: boolean = true;
        if (!sessionStorage.getItem('refNo')) {
            isValid = false
        }
        return isValid;
    }

    public static getToken() {

        return sessionStorage.getItem('AuthToken');
    }
}
